export const STREAK_MILESTONES = [3, 7, 14, 30];

export const STREAK_BADGES: Record<number, { id: string; emoji: string; label: string }> = {
  3:  { id: "streak_3",  emoji: "🥉", label: "3-Day Starter"  },
  7:  { id: "streak_7",  emoji: "🥈", label: "Week Warrior"   },
  14: { id: "streak_14", emoji: "🥇", label: "Fortnight Fire" },
  30: { id: "streak_30", emoji: "👑", label: "Monthly Master" },
};

export const BADGE_BY_ID: Record<string, { emoji: string; label: string }> = Object.fromEntries(
  Object.values(STREAK_BADGES).map(b => [b.id, { emoji: b.emoji, label: b.label }])
);

export function getHighestBadge(earnedBadges: string[]): { emoji: string; label: string } | null {
  const order = [30, 14, 7, 3];
  for (const n of order) {
    const b = STREAK_BADGES[n];
    if (earnedBadges.includes(b.id)) return b;
  }
  return null;
}
